module.exports = __webpack_public_path__ + "img/femmede.019ccb7a.png";